import * as React from "react";
import Header from "./Header";
import ChatMessageBox from "./ChatMessageBox";
import ConfigContext from "../context/ConfigContext";
import * as Icons from "./Icons";
import { EngagementConfiguration } from "../types";
import MessengerFlexContainer from "./MessengerFlexContainer";

interface ConfigExtension {
  config: EngagementConfiguration;
}

interface IntroMessageFormProps {
  isPopout: boolean;
  onCollapse: () => void;
  onSubmit: (message: string) => void;
  onClose: () => void;
}

interface IntroMessageFormState {
  text: string;
}

class IntroMessageForm extends React.Component<
  IntroMessageFormProps & ConfigExtension,
  IntroMessageFormState
> {
  state = {
    text: ""
  };

  form: HTMLDivElement;

  onChangeText = (text: string) => {
    this.setState({ text });
  };

  sendText = () => {
    if (this.state.text) {
      this.props.onSubmit(this.state.text);
    }
  };

  render() {
    return (
      <MessengerFlexContainer>
        <Header
          isPopout={this.props.isPopout}
          onCollapse={this.props.onCollapse}
        />
        <div className="velaro-message-list velaro-scroll">
          <div className="velaro-intro-text">
            {this.props.config.IntroductionText}
          </div>
        </div>
        <div
          className="velaro-message-form"
          ref={(el) => (this.form = el)}
          tabIndex={0}
        >
          <ChatMessageBox
            value={this.state.text}
            onChange={this.onChangeText}
            onEnter={this.sendText}
            placeholder={this.props.config.IntroPlaceholder}
          />
          <div className="velaro-message-form-actions">
            <button
              className="velaro-message-send-button velaro-bg-primary"
              onClick={this.sendText}
              aria-label="Begin chatting"
            >
              <Icons.SendIcon color={this.props.config.PrimaryTextColor} />
            </button>
          </div>
        </div>
      </MessengerFlexContainer>
    );
  }
}

export default (props: IntroMessageFormProps) => (
  <ConfigContext.Consumer>
    {(config) => <IntroMessageForm config={config} {...props} />}
  </ConfigContext.Consumer>
);
